// extracted by mini-css-extract-plugin
export default {"buttonGroupItem":"DialogButton_buttonGroupItem__GJuiH"};